import React, { useContext, useEffect, useState, } from "react";
import axios from "axios";
import MapPin from "@assets/MapPin.svg"
import { DealerContext } from "../../contexts/DealerContext.jsx";
import Result from "./Result.jsx"

const PDPDealerAccordion = ({radius}) => {

    const { dealers, loading, setBounds } = useContext(DealerContext);
    const [ show, setShow ] = useState(__VPV?.pdp?.use_vpv_button === false);
    const [ view, setView ] = useState(false);

    useEffect(() => {
        getLocation();
        if(__VPV?.pdp?.use_vpv_button === false){
            setShow(true);
            return;
        }
        const onVehicleSelected = () => {
            setShow(__VPV.vehicleSelected);
        }
        onVehicleSelected();
        document.addEventListener('vehicleSelected', onVehicleSelected);
        document.addEventListener('vehicleCleared', onVehicleSelected);
        return () => {
            document.removeEventListener('vehicleSelected', onVehicleSelected);
            document.removeEventListener('vehicleCleared', onVehicleSelected);
        }
    }, []);

    useEffect(() => {
        if(show && (view == "accordion" || view == "button") && dealers.length > 0){
            const location = JSON.parse(window.localStorage.getItem('location'));
            window.heap.track('See it in person', {
                dealers: dealers.length,
                view: view,
                state: location.state,
                lat: location.lat,
                lng: location.lng
            });
        }
    }, [dealers, show, view]);

    const getLocation = async () => {

        let location = null;

        if(window.localStorage && window.localStorage.getItem('location')){
            location = JSON.parse(window.localStorage.getItem('location'));
        }

        if(!location || !location.state || !location.lat || !location.lng){
            const ipLocation = await axios("https://api.ipgeolocation.io/ipgeo?apiKey=e68619601ad94318be902933c965d96f", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            location = {
                state: ipLocation.data.state_code.split('-')[1],
                lat: ipLocation.data.latitude,
                lng: ipLocation.data.longitude
            };

            if (window.localStorage) {
                window.localStorage.setItem('location', JSON.stringify(location));
            }
        }

        growth_book.setAttributes({
            // Only update the `url` attribute, keep the rest the same
            ...growth_book.getAttributes(),
            ...location
        });
        await growth_book.refreshFeatures();

        const view = growth_book.getFeatureValue("see-it-in-person");

        if(location){
            setView(view);
            setBounds({
                country: "US",
                lat: location.lat,
                lng: location.lng,
                zoom: 10
            });
        }
    }

    let location = {};

    if(window.localStorage && window.localStorage.getItem('location')){
        location = JSON.parse(window.localStorage.getItem('location'));
    }

    // dealer distance is in meters so we need to convert the radius to meters
    const filteredDealers = dealers?.filter(dealer => dealer.distance < radius * 1609.34);

    if(show && view == "accordion" && filteredDealers.length > 0){
        return (
            <details id="see-it-in-person" class=" accordion group" aria-expanded="true" is="accordion-disclosure" open>
                <summary>
                    <div class="accordion__toggle bold">
                        <span class="text-with-icon">
                            <MapPin />
                            <span>Find a Store Near You</span>
                        </span>
                        <span class="circle-chevron group-hover:colors group-expanded:colors group-expanded:rotate">
                            <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                                <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
                            </svg>
                        </span>
                    </div>
                </summary>

                <div class="accordion__content">
                    <div class="prose mb-4">
                        <p>
                            See if this product is in stock at the store nearest to you. <a href={`/pages/dealer-locator/search?lat=${location.lat}&lng=${location.lng}`}>See all stores.</a>
                        </p>
                    </div>
                    <div class="ft_dealer-locator__results__search-bar">
                        <Result dealer={filteredDealers[0]} className={"ft_dealer-locator__results__list__item"} hideDisplay={true} milesBadge={true} />
                    </div>
                </div>
            </details>
        );
    }else if(show && view == "button" && filteredDealers.length > 0){
        return (
            <a href={`/pages/dealer-locator/search?lat=${location.lat}&lng=${location.lng}`} class="button button--outline button--xl w-full">
                See it in person ({filteredDealers.length} dealer{filteredDealers.length > 1 ? 's' : ''})
            </a>
        );
    }

    return null;
}

export default PDPDealerAccordion;